module.exports = __webpack_public_path__ + "static/media/default_link.9f2db957.png";